export default __webpack_public_path__ + "static/media/ig-post-1.6403cad4.jpeg";